import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { IHeaderGroupAngularComp } from 'ag-grid-angular';
import { IHeaderGroupParams } from 'ag-grid-community';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'ac-header-group-cell-renderer',
	template: `
         <div class="d-flex header-group-container" [id]="groupId"
		 	custom-tracking
			[track-event]="tableName + ':table:header-group:dimension:'+ params.displayName + (isExpanded ? ':collapse' : ':expand')"
			[ngClass]="{
            	'header-group-single-column': visibleChildrenCount === 1 && !isExpanded,
            	'header-group-double-column': ((visibleChildrenCount >1 && !isExpanded) || isExpanded),
				'expandable': isExpandable
        }">
		<span>{{ this.params.displayName | uppercase }}</span>
            <ng-container *ngIf="isExpandable">
                <div class="ac-text-button" *ngIf="isExpanded">
					<ac-cta-link *ngIf="visibleChildrenCount + hiddenChildrenCount > 1" class="text-12 orange-border">
						<dz-icon type="angle-double-left"></dz-icon>
						<span [dcrHTMLKey]="tableName + '_COLUMN_COLLAPSE'">Collapse</span>
					</ac-cta-link>
                </div>
                <div class="ac-text-button" *ngIf="!isExpanded">
					<ac-cta-link class="text-12 orange-border">
						<span *ngIf="visibleChildrenCount > 1" [dcrHTMLKey]="tableName + '_COLUMN_EXPAND'">Expand</span>
						<dz-icon type="angle-double-right"></dz-icon>
					</ac-cta-link>
                </div>
            </ng-container>
        </div>
   `
})
export class HeaderGroupCellRendererComponent implements IHeaderGroupAngularComp {
	public params: IHeaderGroupParams;
	public isExpanded: boolean;
	public isExpandable: boolean;
	public visibleChildrenCount: number;
	public hiddenChildrenCount: number;
	public groupId: string;
	public tableName: string;

	constructor(private ref: ChangeDetectorRef) { }

	public agInit(params: IHeaderGroupParams): void {
		this.params = params;
		this.tableName = params['tableName'] ?? 'investment-details';
		this.updateVisibleChildren();

		setTimeout(() => {
			const headerGrpElements = Array.from(document.getElementsByClassName('group-header'));
			headerGrpElements?.forEach((element) => {
				element.addEventListener('click', () => {
					this.toggleColumnExpansion(element);
				});
			});
		}, 0);
	}

	public refresh(): boolean {
		return false;
	}

	private toggleColumnExpansion(column: Element): void {
		const colId = column?.getAttribute('col-id');

		if (colId?.includes(this.groupId)) {
			const currentState: boolean = this.params?.columnGroup?.getProvidedColumnGroup()?.isExpanded();
			this.isExpanded = !currentState;
			this.params?.setExpanded(this.isExpanded);
			this.updateVisibleChildren();
			this.ref.detectChanges();
		}
	}

	private updateVisibleChildren(): void {
		this.setDefaultValue();

		const childrenCount: number = this.params?.columnGroup?.['children']?.length ?? 0;
		this.visibleChildrenCount = this.params?.columnGroup?.getDisplayedChildren()?.length ?? 0;
		this.hiddenChildrenCount = childrenCount - this.visibleChildrenCount;
	}

	private setDefaultValue(): void {
		this.isExpandable = this.params?.columnGroup?.getProvidedColumnGroup()?.isExpandable();
		this.isExpanded = this.params?.columnGroup?.getProvidedColumnGroup()?.isExpanded();
		this.groupId = this.params?.columnGroup?.getGroupId();
	}
}
